var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmcInvestStackedBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 209,
    viewBox: "0 0 436 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9873_1289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6 55.427C27.6 43.7424 22.1 38.1497 11.8 34.5544C7.7 33.1563 3.8 32.1576 0 31.2588V121.84H20.5C24.4 121.84 27.6 118.444 27.6 114.25V55.427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9 39.8479C68.9 28.1633 63.4 22.4707 53.1 18.9753C49 17.5772 45.1 16.5785 41.4 15.6797V121.84H61.8C65.7 121.84 68.9 118.444 68.9 114.25V39.8479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6 3.29566C88.3 6.89093 82.8 12.4836 82.8 24.0683V121.84H103.3C107.2 121.84 110.4 118.444 110.4 114.25V0C106.7 0.898817 102.7 1.8975 98.7001 3.29566H98.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1 14.1816C151.4 14.1816 131.1 32.8571 131.1 68.7099C131.1 104.563 151.4 123.238 181.1 123.238C190 123.238 200 121.041 211.6 117.745L216.7 116.347V96.3734L208.6 98.7703C198.2 101.666 189.7 103.664 183.2 103.664C164.3 103.664 154.7 92.3787 154.7 68.8097C154.7 45.2408 164.3 33.7559 183.2 33.7559C189.7 33.7559 198.2 35.953 208.6 38.6494L216.7 41.0463V20.9727L211.6 19.5745C200 16.2789 189.9 14.2815 181.1 14.2815V14.1816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.4 92.4781L253.9 51.6319V121.939H233.2V15.4795H253.3L284.7 64.2153L315.9 15.4795H335.7V121.839H314.8V52.0314L287.6 92.4781H281.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.4 14.1816C370.7 14.1816 350.4 32.8571 350.4 68.7099C350.4 104.563 370.7 123.238 400.4 123.238C409.3 123.238 419.3 121.041 430.9 117.745L436 116.347V96.3734L427.9 98.7703C417.5 101.666 409 103.664 402.5 103.664C383.6 103.664 374 92.3787 374 68.8097C374 45.2408 383.6 33.7559 402.5 33.7559C409 33.7559 417.5 35.953 427.9 38.6494L436 41.0463V20.9727L430.9 19.5745C419.3 16.2789 409.2 14.2815 400.4 14.2815V14.1816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 207.127H271V198.638H239.2V178.664H268.1V170.276H239.2V151.8H271V143.511H230V207.127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 143.511H0V207.127H9.3V143.511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7 189.65L61.4 143.511H52.8V207.127H61.8V158.791L95.8001 207.127H102.6V143.511H93.7V189.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.3 172.473L328.3 168.578C322.4 166.381 319.2 164.184 319.2 159.39C319.2 152.999 325.3 150.702 331.1 150.702C337.6 150.702 343.3 152.699 348.8 157.093L349.8 157.892V147.906L349.5 147.706C344.6 144.31 338 142.513 330.9 142.513C320.4 142.513 309.9 147.806 309.9 159.49C309.9 169.877 317.3 174.171 324.6 176.967L333.9 180.563C340.6 183.359 343.7 185.356 343.7 190.45C343.7 196.242 338.9 199.737 330.8 199.737C323.3 199.737 316.9 197.44 311.2 192.547L310.2 191.648V201.934L310.4 202.134C315.3 205.929 322.7 208.026 330.8 208.026C344 208.026 352.8 200.936 352.8 190.35C352.8 181.661 348.5 176.268 338.3 172.473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.3 194.244L146.1 143.511H136.4L161 207.127H169.4L194 143.511H184.5L165.3 194.244Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.2 151.7H405.5V207.027H414.8V151.7H436V143.411H384.2V151.7Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9873_1289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436,
    height: 208.026,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmcInvestStackedBlack);
export default __webpack_public_path__ + "static/media/CMC-Invest_stacked_black.2fb0e86ad52871592706f882f525745c.svg";
export { ForwardRef as ReactComponent };